
// api
import courseApi from "@comp/vodCourse/vodCourseApi";
import vipApi from "@api/vip";
import datumApi from "@api/datum";

// platformApi
import requestManager from "@comp/platformApi/requestManager";

// util
import appHelper from "@util/appHelper";
import objectHelper from "@util/objectHelper";
import externalApp from "@data/externalApp";

export default {
    props : {
        userInstance : Object,
        agreeServiceProtocol : Boolean
    },
    data() {
        return {
            vipType : null,
            privilegeList : [],
            equitiesList : [],  // N大权益的广告
            presentedList : [], // 礼品
            customerServiceQrDrawer : {
                qrUrl : ''
            },
            courseListOptions : {
                page : 1,
                totalPage : 0
            },
            datumListOptions : {
                page : 1,
                totalPage : 0
            }
        }
    },
    methods : {

        changeAgreeServiceProtocol(event) {
            let target = event.currentTarget;
            let status = target.checked;
            this.$emit('changeAgreeServiceProtocol', {
                status : status
            });
        },
        receiveGift(giftItem) {
            if(giftItem.type === 'qr')
            {
                this.customerServiceQrDrawer.qrUrl = giftItem.resource;
                if (typeof (this.$refs.customerServiceQrDrawer) !== 'undefined')
                {
                    this.$refs.customerServiceQrDrawer.open();
                }
            }
            else if (giftItem.type === 'email')
            {
                if (typeof (this.$refs.downloadToEmailDrawer) !== 'undefined')
                {
                    this.$refs.downloadToEmailDrawer.vipEnjoyId = giftItem.id;
                    this.$refs.downloadToEmailDrawer.reset();
                    this.$refs.downloadToEmailDrawer.open();
                }
            }
        },
        viewCourse(dataItem) {
            let url = '/learn/course/' + dataItem.id;
            appHelper.redirect(url);
        },
        viewDatum(dataItem) {
            let url = externalApp.oldShixun.baseUrl + 'html/downloadDetail.html?id=' + dataItem.id;
            appHelper.redirect(url);
        },
        loadVipEnjoyInfo() {

            const me = this;

            if (!this.vipType)
            {
                return;
            }

            let requestOptions = objectHelper.clone(vipApi.vipEnjoy);
            requestOptions.params = {
                vipType : this.vipType.code
            };

            requestManager.request(requestOptions, (error, result) => {
                if (error)
                {
                    appHelper.showHint(error.toString());
                    return;
                }

                // type: Array
                me.privilegeList = result.data.privilege;
                me.equitiesList  = result.data.equities;
                me.presentedList = result.data.presented;
            });
        },
        downloadToEmail(options = {}) {
            // appHelper.showMessage('提示', '该功能暂未开放，敬请期待！');
            let vipEnjoyId = options.vipEnjoyId || '';
            let email = options.email || '';
            let api = objectHelper.clone(vipApi.sendVipEnjoyEmail);
            api.data = {
                vipEnjoyId : vipEnjoyId,
                email : email,
            };
            requestManager.request(api, (error, result) => {
                if (error)
                {
                    appHelper.generalAjaxError(error);
                    return;
                }

                let errorCode = result.errorCode || 0;

                if (errorCode)
                {
                    appHelper.showHint(result.msg);
                    return;
                }

                appHelper.showHint('发送成功，请查收！');
            });
        },
        goToIntegralPage() {
            appHelper.redirect('/integral');
        }
    },
    mounted() {
        this.loadVipEnjoyInfo();
    }
}
